class Range {

    constructor($el, stepLabels = null) {
        this.$el = $el;
        this.$input = $el.find('input');

        this.options = {
            min: parseFloat(this.$input.attr('min')),
            max: parseFloat(this.$input.attr('max')),
            step: parseFloat(this.$input.attr('step')).toFixed(2),
        };

        this.options.stepCount = (this.options.max - this.options.min) / this.options.step;
        this.options.stepSize = 100 / this.options.stepCount;
        this.options.percentage = this.$el.data('percentage') ? true : false;

        this.$valueUi = null;
        this.stepLabels = stepLabels;
        this.$stepLabel = null;

        this.init();
    }

    init = () => {
        this.generateDom();
        this.$input.on('input', this.inputChangeHandler);
        this.inputChangeHandler();
    }

    generateDom = () => {
        // base UI
        let ui = document.createElement("div");
        ui.className = "range__ui";
        this.$el.append(ui);

        // min
        let min = document.createElement("div");
        min.className = "range__scope range__scope--start";
        min.textContent = !this.options.percentage ? this.options.min : `${parseFloat(this.options.min) * 100}%`;
        this.$el.append(min);

        // max
        let max = document.createElement("div");
        max.className = "range__scope range__scope--end";
        max.textContent = !this.options.percentage ? this.options.max : `${parseFloat(this.options.max) * 100}%`;
        this.$el.append(max);

        // current value
        let valueUi = document.createElement("div");
        valueUi.className = "range__value";
        this.$el.append(valueUi);

        // step label
        if(this.stepLabels) {
            let stepLabel = document.createElement("p");
            stepLabel.className = "range__step-label";
            this.$el.parent().find('.range__bottom').prepend(stepLabel);
            this.$stepLabel = $(stepLabel);
        }

        this.$valueUi = $(valueUi);

        // steps indicator
        for (let i = 0; i <= this.options.stepCount; i++) {
            let div = document.createElement("div");

            div.className = "range__indicator";
            div.style = `left: ${this.options.stepSize * i}%;`

            $(ui).append(div);
        }
    }

    inputChangeHandler = () => {
        const value = this.$input.val();

        if(!this.options.percentage) {
            this.$valueUi.text(value);
        } else {
            const percent = parseFloat(value) * 100;
            this.$valueUi.text(`${percent}%`);
        }

        let left = ((value - this.options.min) / this.options.step) * this.options.stepSize;

        this.$valueUi.css({
            'left': `${left}%`
        });

        if (this.stepLabels) {
            this.$stepLabel.text(this.stepLabels[value]);
        }
    }
}

export default Range;
